import { noDataImage } from '@rootCommon/images';

const NoDataImage = (): JSX.Element => (<img src={noDataImage} alt="No data found" />);

export { NoDataImage };

export default NoDataImage;
